/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  LinearProgress,
  makeStyles,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageBanner from '../../components/utils/PageBanner';
import SimpleAlert from '../../components/utils/SimpleAlert';
import AssetManagementFiltersBar from '../../components/FilterBar';
import { useProject } from '../../config/ProjectContext';
import WaveAccordion from '../../components/Wave/WaveAccordion';
import GraphqlService from '../../service/graphqlService';
import YesNoDialog from '../../components/utils/YesNoDialog';
import PaginationComponent from '../../components/Pagination';
import ProgressDialog from '../../components/utils/ProgressDialog';
import { useSnackbar } from '../../providers/SnackbarContext';
import MessageCard from '../../components/utils/MessageCard';
import useAnalytics from '../../hooks/useAnalytics';
import useRegionFeatureGate from '../../hooks/useRegionFeatureGate';

export default function WaveList() {
  const { setAnalytics } = useAnalytics();
  const useStyles = makeStyles((theme) => ({
    separate: {
      flexWrap: 'noWrap',
    },
    headerTabPanel: {
      height: 48,
      backgroundColor: theme.palette.background.paper,
    },
    pagination: {
      background: theme.palette.background.paper,
      borderRadius: 12,
      boxShadow: theme.customShadows.regularShadow,
      color: theme.palette.primary.text,
      float: 'right',
      padding: 0,
      width: '100%',
    },
    labelHeaderTabPanel: {
      color: theme.palette.primary.subMain,
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '16px',
      fontWeight: theme.typography.fontWeightBold,
      letterSpacing: '0',
      lineHeight: '19px',
      textAlign: 'center',
      width: '720px',
      height: '48px',
    },
    background: {
      backgroundColor: theme.palette.background.default,
    },
    button: {
      float: 'right',
      margin: '0 0 16px 24px',
    },
    tableIcons: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: 24,
      flexWrap: 'wrap',
    },
    filtersContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      padding: theme.spacing(3),
      gap: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderRadius: 12,
      marginBottom: theme.spacing(2),
      boxShadow: theme.customShadows.regularShadow,
      flexWrap: 'wrap',
    },
    selectPaginationSize: {
      marginRight: '8px',
      borderRadius: 12,
    },
    fileTypeFilterStyle: {
      minWidth: 410,
      marginTop: 6,
    },
    orderDateStyle: {
      minWidth: 130,
      marginTop: 6,
    },
    waveIdFilterStyle: {
      minWidth: 450,
      borderRadius: 12,
      marginRight: 8,
    },
  }));

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { project } = useProject();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertId, setAlertId] = useState('');
  const [alertText, setAlertText] = useState('');
  const [sortDirection, setSortDirection] = useState('DESC');
  const [lastProjectCode, setLastProjectCode] = useState(null);
  const [waveFileTypeFilter, setWaveFileTypeFilter] = useState(null);
  const [lastWaveFileTypeFilter, setLastWaveFileTypeFilter] = useState();
  const [selectedWaveFileTypes, setSelectedWaveFileTypes] = useState([]);
  const [yesNoDialogOpen, setYesNoDialogOpen] = useState(false);
  const [yesNoDialogText, setYesNoDialogText] = useState('');
  const [waveToDelete, setWaveToDelete] = useState(null);
  const [selectedFilterField, setSelectedFilterField] = React.useState('');
  const [filterValue, setfilterValue] = React.useState(null);
  const [datetimeFrom, setDatetimeFrom] = useState(null);
  const [datetimeTo, setDatetimeTo] = useState(null);
  const [waveDescriptionValueFilter, setWaveDescriptionValueFilter] = useState(null);
  const [_debouncedWaveDescriptionValueFilter, setDebouncedWaveDescriptionValueFilter] = useState(null);
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);
  const openSnackBar = useSnackbar();

  const isFeatureAvailable = useRegionFeatureGate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [hasInitializedSearch, setHasInitializedSearch] = useState(false);

  const [releaseIdFilter, setReleaseIdFilter] = useState(null);
  const [_debouncedReleaseIdFilter, setDebouncedReleaseIdFilter] = useState(null);

  const [deployIdFilter, setDeployIdFilter] = useState(null);
  const [_debouncedDeployIdFilter, setDebouncedDeployIdFilter] = useState(null);

  const [fileIdFilter, setFileIdFilter] = useState(null);
  const [_debouncedFileIdFilter, setDebouncedFileIdFilter] = useState(null);

  const [waveIdFilter, setWaveIdFilter] = useState(null);
  const [_debouncedWaveIdFilter, setDebouncedWaveIdFilter] = useState(null);

  const {
    waveID: waveIDParam,
    waveDescriptionKey: waveDescriptionKeyParam,
    waveDescriptionValue: waveDescriptionValueParam,
  } = useParams();

  const handleDeleteClick = () => {
    setAnalytics({
      event: 'button_clicked',
      extraParams: { name: 'asset_management-waves-delete' }
    });
  };

  // Trigger automatic search on initial page load
  useEffect(() => {
    if (!hasInitializedSearch && project?.code) {
      setIsSearchTriggered(true);
      setHasInitializedSearch(true);
    }
  }, [project?.code, hasInitializedSearch]);

  const getFileType = waveFileTypeFilter === null ? null : waveFileTypeFilter;

  function openAlert(header, text, id) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
    setAlertId(id);
  }

  const getWave = async () => GraphqlService.getWaveById(project?.code, waveIDParam);

  const handleSearchClick = () => {
    // If waveIdFilter is provided, fetch specific wave using getWaveById
    if (waveIdFilter) {
      refetchWaveFromFilter();
      return;
    }

    // Apply all staged filters to the active filter states
    if (waveDescriptionValueFilter) {
      setDebouncedWaveDescriptionValueFilter(waveDescriptionValueFilter);
    } else {
      setDebouncedWaveDescriptionValueFilter(null);
    }
    if (fileIdFilter) {
      setDebouncedFileIdFilter(fileIdFilter);
    } else {
      setDebouncedFileIdFilter(null);
    }
    if (releaseIdFilter) {
      setDebouncedReleaseIdFilter(releaseIdFilter);
    } else {
      setDebouncedReleaseIdFilter(null);
    }
    if (deployIdFilter) {
      setDebouncedDeployIdFilter(deployIdFilter);
    } else {
      setDebouncedDeployIdFilter(null);
    }
    // Trigger the search
    setIsSearchTriggered(true);
  };

  const handleFilterChipDelete = (filterName) => {
    // Reset the filter value
    let newFileIdFilter = fileIdFilter;
    let newReleaseIdFilter = releaseIdFilter;
    let newDeployIdFilter = deployIdFilter;
    let newWaveDescriptionFilter = waveDescriptionValueFilter;

    if (filterName === 'waveFileTypes') {
      setSelectedWaveFileTypes([]);
      setWaveFileTypeFilter(null);
    } else if (filterName === 'fileIdFilter') {
      newFileIdFilter = null;
      setFileIdFilter(null);
    } else if (filterName === 'releaseIdFilter') {
      newReleaseIdFilter = null;
      setReleaseIdFilter(null);
    } else if (filterName === 'deployIdFilter') {
      newDeployIdFilter = null;
      setDeployIdFilter(null);
    } else if (filterName === 'waveIdFilter') {
      setWaveIdFilter(null);
    } else if (filterName === 'waveDescriptionValue') {
      newWaveDescriptionFilter = null;
      setWaveDescriptionValueFilter(null);
    } else if (filterName === 'datetimeFrom') {
      setDatetimeFrom(null);
    } else if (filterName === 'datetimeTo') {
      setDatetimeTo(null);
    } else if (filterName === 'sortDirection') {
      setSortDirection('DESC');
    }
    
    // Apply the remaining filters to debounced versions
    setDebouncedWaveDescriptionValueFilter(newWaveDescriptionFilter);
    setDebouncedFileIdFilter(newFileIdFilter);
    setDebouncedReleaseIdFilter(newReleaseIdFilter);
    setDebouncedDeployIdFilter(newDeployIdFilter);
    
    // Trigger search with updated filters
    setIsSearchTriggered(true);
  };

  const {
    data: waveFromParams,
    isLoading: isLoadingWave,
  } = useQuery(['wave', waveIDParam], () => getWave(), {
    enabled: !!waveIDParam && !!project?.code,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });

  const getWaveByFilter = async () => {
    if (!waveIdFilter) return null;
    return GraphqlService.getWaveById(project?.code, waveIdFilter);
  };

  const {
    data: waveFromFilter,
    isLoading: isLoadingWaveFromFilter,
    refetch: refetchWaveFromFilter,
  } = useQuery(['waveFilter', waveIdFilter, project?.code], () => getWaveByFilter(), {
    enabled: !!waveIdFilter && !!project?.code,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });

  const fetchWaves = async () => {
    if (!isSearchTriggered) return { data: [], pagination: null };
    
    if (
      project?.code !== lastProjectCode
      || waveFileTypeFilter !== lastWaveFileTypeFilter
    ) {
      setCurrentPage(0);
      setLastProjectCode(project?.code);
      setLastWaveFileTypeFilter(waveFileTypeFilter);
    }
    return GraphqlService.listPaginatedWaves({
      projectId: project?.code,
      page: currentPage,
      pageSize,
      sortDirection,
      fileType: getFileType,
      waveDescriptionKey: _debouncedWaveDescriptionValueFilter ? 'userDescription' : undefined,
      waveDescriptionValue: _debouncedWaveDescriptionValueFilter,
      fileID: _debouncedFileIdFilter,
      releaseID: _debouncedReleaseIdFilter,
      deployID: _debouncedDeployIdFilter,
      datetimeFrom: datetimeFrom ? Math.floor(new Date(datetimeFrom).getTime() / 1000).toString() : undefined,
      datetimeTo: datetimeTo ? Math.floor(new Date(datetimeTo).getTime() / 1000).toString() : undefined,
    });
  };

  const {
    data: waves,
    error: errorFetchingWaves,
    isLoading: isLoadingWaves,
    refetch,
  } = useQuery(
    [
      'waves',
      project?.code,
      project?.permission,
      currentPage,
      pageSize,
      sortDirection,
      waveFileTypeFilter,
      _debouncedFileIdFilter,
      _debouncedReleaseIdFilter,
      _debouncedDeployIdFilter,
      _debouncedWaveDescriptionValueFilter,
      datetimeFrom,
      datetimeTo,
      isSearchTriggered,
    ],
    () => fetchWaves({
      projectId: project?.code,
      page: currentPage,
      pageSize,
      sortDirection,
      fileType: getFileType,
      _debouncedReleaseIdFilter,
      waveDescriptionKey: waveDescriptionKeyParam,
      waveDescriptionValue: waveDescriptionValueParam,
    }),
    {
      enabled: !!project && !waveIDParam,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      cacheTime: 0,
    },
  );

  const fetchWaveFileTypes = async () => GraphqlService.getDeploymentFileTypes({
    projectId: project?.code,
  });

  const {
    data: waveFileTypes,
    isLoading: isLoadingWaveFileTypes,
  } = useQuery(['waveFileTypes', project?.code, project?.permission, currentPage, pageSize, sortDirection], () => fetchWaveFileTypes({
    projectId: project?.code,
  }), {
    enabled: !!project && isFeatureAvailable('deploymentFileTypes'),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    cacheTime: 0,
  });

  const handleDeploymentFileTypeFilterChange = (event) => {
    const { value } = event.target;
    // Need to handle the selection as an array
    setSelectedWaveFileTypes(value);
    // transform the array in a string with values sepparated by commas
    if (!value) {
      setWaveFileTypeFilter(null);
    } else setWaveFileTypeFilter(value.join(',').toString());
  };

  async function deleteWaveFunc(wave) {
    try {
      setIsDeleting(true);
      await GraphqlService.deleteWave(project?.code, wave.waveID);
      refetch();
      setIsDeleting(false);
      openSnackBar('Wave deleted successfully');
    } catch (error) {
      setIsDeleting(false);
      openAlert(
        'Error',
        `Error deleting wave ${wave.waveID}: ${error.message}`,
        'closeAlertDeleteWaveError',
      );
    }
  }

  const handleOrderByChange = (event) => {
    setSortDirection(event.target.value);
  };

  const onClickDeleteWave = (waveId) => {
    const wave = waves.data.find((w) => w.waveID === waveId);
    if (wave) {
      setWaveToDelete(wave);
      setYesNoDialogText(
        `You are about to delete wave ${wave.waveID}. Are you sure?`,
      );
      setYesNoDialogOpen(true);
    } else {
      openAlert(
        "Wave can't be found",
        "The requested wave couldn't be found",
        'closeAlertDeleteWaveNotFoundError',
      );
    }
  };

  const getLabel = (filterField) => {
    if (filterField === 'fileIdFilter') return 'File ID';
    if (filterField === 'releaseIdFilter') return 'Bundle ID';
    if (filterField === 'deployIdFilter') return 'Deploy ID';
    return '';
  };

  const classes = useStyles();
  const handlePageChange = (event, value) => {
    setCurrentPage(value - 1);
  };

  const handleSelectChange = (event) => {
    setPageSize(event.target.value);
  };

  const handleChangeSelectedFilter = (event) => {
    setSelectedFilterField(event.target.value);
    setfilterValue(null);
    setDebouncedDeployIdFilter(null);
    setDebouncedReleaseIdFilter(null);
    setDebouncedFileIdFilter(null);
    setDatetimeFrom(null);
    setDatetimeTo(null);
  };

  const handleChangeFilterValue = (value) => {
    setfilterValue(value);
    if (selectedFilterField === 'fileIdFilter') {
      setDebouncedFileIdFilter(value);
    }
    if (selectedFilterField === 'releaseIdFilter') {
      setDebouncedReleaseIdFilter(value);
    }
    if (selectedFilterField === 'deployIdFilter') {
      setDebouncedDeployIdFilter(value);
    }
  };

  if (!project || waves?.length === 0) {
    return <MessageCard message="No waves retrieved" />;
  }

  if ((isLoadingWaves || isLoadingWave || isLoadingWaveFromFilter || !project?.code) && !waveFromParams && !waveFromFilter && !waves) {
    return (
      <>
        <ProgressDialog open header={isLoadingWave || isLoadingWaveFromFilter ? 'Retrieving the wave, please wait' : 'Retrieving waves, please wait'} />
        <LinearProgress style={{ width: '100%' }} />
      </>
    );
  }

  if (isDeleting) {
    return (
      <>
        <ProgressDialog open header="Deleting waves, please wait" />
        <LinearProgress style={{ width: '100%' }} />
      </>
    );
  }

  if (errorFetchingWaves) {
    return (
      <SimpleAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        header="Error"
        body={errorFetchingWaves.message}
        id="closeAlertErrorFetchingWaves"
      />
    );
  }

  if (waveFromParams) {
    return (
      <Box>
        <WaveAccordion
          wave={waveFromParams}
          key={waveFromParams.waveID}
          id="txtWavedetail"
          expandedProp
          onWaveUpdate={refetch}
        />
      </Box>
    );
  }

  if (waveFromFilter) {
    return (
      <Box>
        <WaveAccordion
          wave={waveFromFilter}
          key={waveFromFilter.waveID}
          id="txtWavedetailFromFilter"
          expandedProp
          onWaveUpdate={refetchWaveFromFilter}
        />
      </Box>
    );
  }

  return (
    <Box>
      <YesNoDialog
        open={yesNoDialogOpen}
        setOpen={setYesNoDialogOpen}
        header="Delete Wave"
        body={yesNoDialogText}
        action={() => deleteWaveFunc(waveToDelete)}
        actionName="Yes"
        id="confirmationDeleteWave"
      />
      <SimpleAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        header={alertHeader}
        body={alertText}
        id={alertId}
      />
      <PageBanner title="WAVES" />

      <Box style={{ padding: 16 }}>
        {
          waveFileTypes?.data?.length > 0 && !isLoadingWaveFileTypes && (
            <AssetManagementFiltersBar
              title="Filters"
              projectCode={project?.code}
              onSearch={handleSearchClick}
              onFilterDelete={handleFilterChipDelete}
              filters={[
              {
                type: 'select',
                name: 'waveFileTypes',
                label: 'File Type',
                options: waveFileTypes.data.map((fileType) => ({
                  value: fileType,
                  label: fileType,
                })),
                multiple: true,
                size: 'medium',
              },
              {
                type: 'search',
                name: 'fileIdFilter',
                label: 'File ID',
                placeholder: 'Search by File ID',
                size: 'large',
              },
              {
                type: 'search',
                name: 'releaseIdFilter',
                label: 'Bundle ID',
                placeholder: 'Search by Bundle ID',
                size: 'large',
              },
              {
                type: 'search',
                name: 'deployIdFilter',
                label: 'Deploy ID',
                placeholder: 'Search by Deploy ID',
                size: 'large',
              },
              {
                type: 'search',
                name: 'waveIdFilter',
                label: 'Wave ID',
                placeholder: 'Search by Wave ID',
                size: 'large',
              },
              {
                type: 'search',
                name: 'waveDescriptionValue',
                label: 'Description',
                placeholder: 'Search by Description',
                size: 'large',
              },
              {
                type: 'datetime-local',
                name: 'datetimeFrom',
                label: 'Date From',
                size: 'medium',
              },
              {
                type: 'datetime-local',
                name: 'datetimeTo',
                label: 'Date To',
                size: 'medium',
              },
              {
                type: 'select',
                name: 'sortDirection',
                label: 'Sort by Date',
                options: [
                  { value: 'ASC', label: 'Ascending' },
                  { value: 'DESC', label: 'Descending' },
                ],
                size: 'small',
              },
            ]}
            activeFilters={{
              waveFileTypes: selectedWaveFileTypes,
              fileIdFilter: fileIdFilter,
              releaseIdFilter: releaseIdFilter,
              deployIdFilter: deployIdFilter,
              waveIdFilter: waveIdFilter,
              waveDescriptionValue: waveDescriptionValueFilter,
              datetimeFrom,
              datetimeTo,
              sortDirection,
            }}
            onFilterChange={(name, value) => {
              if (name === 'waveFileTypes') {
                setSelectedWaveFileTypes(value);
                if (!value || value.length === 0) {
                  setWaveFileTypeFilter(null);
                } else {
                  setWaveFileTypeFilter(value.join(',').toString());
                }
              } else if (name === 'fileIdFilter') {
                setFileIdFilter(value);
              } else if (name === 'releaseIdFilter') {
                setReleaseIdFilter(value);
              } else if (name === 'deployIdFilter') {
                setDeployIdFilter(value);
              } else if (name === 'waveIdFilter') {
                setWaveIdFilter(value);
              } else if (name === 'waveDescriptionValue') {
                setWaveDescriptionValueFilter(value);
              } else if (name === 'datetimeFrom') {
                setDatetimeFrom(value);
              } else if (name === 'datetimeTo') {
                setDatetimeTo(value);
              } else if (name === 'sortDirection') {
                setSortDirection(value);
              }
            }}
            onClearAll={() => {
              setSelectedWaveFileTypes([]);
              setWaveFileTypeFilter(null);
              setFileIdFilter(null);
              setReleaseIdFilter(null);
              setDeployIdFilter(null);
              setWaveIdFilter(null);
              setDebouncedDeployIdFilter(null);
              setDebouncedReleaseIdFilter(null);
              setDebouncedFileIdFilter(null);
              setWaveDescriptionValueFilter(null);
              setDebouncedWaveDescriptionValueFilter(null);
              setDatetimeFrom(null);
              setDatetimeTo(null);
              setSortDirection('DESC');
              setIsSearchTriggered(true);
            }}
          />
          )
        }
      </Box>

      {
        waves.data?.map((wave, i) => (
          <WaveAccordion
            wave={wave}
            key={wave.waveID}
            id={`accordion-${i}`}
            deleteWave={(waveId) => {
              handleDeleteClick();
              onClickDeleteWave(waveId);
            }}
            onWaveUpdate={refetch}
          />
        ))
      }

      <div className={classes.tableIcons}>
        {waves?.pagination && (
          <PaginationComponent
            pageSize={pageSize}
            handleSelectChange={handleSelectChange}
            pagination={waves.pagination}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </Box>
  );
}
